import * as yup from "yup";
let cityValidationForm = yup.object().shape({
  name: yup.string().required("City Name is required"),
  code: yup.string().required("Code is required"),
  country: yup.string().required("Country  is required"),
  state: yup.string().required("State  is required"),
  parent: yup.string().required("District is required"),
});

let countryValidationForm = yup.object().shape({
  name: yup.string().required("Country Name is required"),
});

let districtValidationForm = yup.object().shape({
  name: yup.string().required("State Name is required"),
  country: yup.string().required("Country  is required"),
  parent: yup.string().required("State is required"),
});
 
let groupValidationForm = yup.object().shape({
  name: yup.string().required("Group Name is required"),
  code: yup.string().required("Currency is required"),
});

let stateValidationForm = yup.object().shape({
  name: yup.string().required("State Name is required"),
  parent: yup.string().required("Country is required"),
});
export {
  cityValidationForm,
  countryValidationForm,
  districtValidationForm,
  groupValidationForm,
  stateValidationForm,
};
